
<template>
  <div id="container"></div>
</template>


<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
    name :'map-contain',
    data(){
      return {
        map: null,
        points:[],
        searchName: ''
      }
    },
    unmounted‌(){
      this.map?.destroy();
    },
    methods: {
      initMap(){
        var ths = this;
        AMapLoader.load({
          key: ths.$gdKey, // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: ["AMap.Scale", "AMap.PlaceSearch"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
          .then((AMap) => {
            ths.map = new AMap.Map("container", {
              // 设置地图容器id
              viewMode: "2D", // 是否为3D地图模式
              //mapStyle: "amap://styles/whitesmoke", //设置地图的显示样式
              zoom: 11, // 初始化地图级别
            });
            ths.map.on('rightclick',function(ev){
              ths.points = []
              ths.map.clearMap();
            });
            ths.map.on('complete', function(){
              if(ths.points){
                ths.addRect()
              }
            });

            ths.map.on("click", function (ev) {
              //触发事件的对象
              var target = ev.target;
              //触发事件的地理坐标，AMap.LngLat 类型
              var lnglat = ev.lnglat;
              //触发事件的像素坐标，AMap.Pixel 类型
              var pixel = ev.pixel;
              //触发事件类型
              var type = ev.type;

              ths.points.push(lnglat);
              console.log(ths.points)
              if(ths.points.length>=3){
                ths.addRect()
              }
            });

          })
          .catch((e) => {
            console.log(e);
          });
      },
      getPoints(){
        return this.points
      },
      setPoints(data){
        this.points = data
      },
      addRect(){
          var ths = this
          ths.map.clearMap();
          var path = [];
          console.log(ths.points)
          for(var i = 0; i < ths.points.length; i++){
            var obj = ths.points[i];
            path.push(new AMap.LngLat(obj.lng, obj.lat))
          }
          //创建多边形 Polygon 实例
          var polygon = new AMap.Polygon({
            path: path, //路径
            fillColor: "#fff", //多边形填充颜色
            strokeWeight: 2, //线条宽度，默认为 2
            strokeColor: "red", //线条颜色
          });
          //多边形 Polygon对象添加到 Map
          ths.map.add(polygon);
          //将覆盖物调整到合适视野
          ths.map.setFitView([polygon])
          //鼠标移入事件
          polygon.on("mouseover", () => {
            polygon.setOptions({
              //修改多边形属性的方法
              fillOpacity: 0.7, //多边形填充透明度
              fillColor: "#7bccc4",
            });
          });
          //鼠标移出事件
          polygon.on("mouseout", () => {
            polygon.setOptions({
              fillOpacity: 1,
              fillColor: "#fff",
            });
          });
          //引入多边形编辑器插件
          ths.map.plugin(["AMap.PolygonEditor"], function () {
            //实例化多边形编辑器，传入地图实例和要进行编辑的多边形实例
            var polygonEditor = new AMap.PolygonEditor(ths.map, polygon);
            //开启编辑模式
            polygonEditor.open();
          });
      }
    }
  }
</script>

<style scoped>
#container {
  width: 100%;
  height: 800px;
}
</style>
